export default {
  LOAD_SESSION_QR_START: 'LoadGeneralCompetencyEventSessionQrStart',
  LOAD_SESSION_QR_END: 'LoadGeneralCompetencyEventSessionQrEnd',
  GENERATE_SESSION_QR_START: 'GenerateGeneralCompetencyEventSessionQrStart',
  GENERATE_SESSION_QR_END: 'GenerateGeneralCompetencyEventSessionQrEnd'
};
